export function useSize(numericSizes:string[], letterSizes: string[]) {
    const getSizes =  (sizeType?:string): string[] => {
        const sizeTypeConverted = sizeType?.toString()?.toLowerCase()
        if (sizeTypeConverted === 'letter') {
            return letterSizes
        }

        if (sizeTypeConverted === 'number') {
            return numericSizes
        }

        return [...letterSizes, ...numericSizes]
    }

    return {
        getSizes
    }
}
